import { createElement, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

import { Urls } from './Urls';

const MainPage = lazy(() =>
  import('@/pages/main').then((module) => ({ default: module.MainPage })),
);

const PoAllPage = lazy(() =>
  import('@/pages/po-all').then((module) => ({ default: module.PoAllPage })),
);

const PoActionPage = lazy(() =>
  import('@/pages/po-action').then((module) => ({
    default: module.PoActionPage,
  })),
);

const PoSubmittedPage = lazy(() =>
  import('@/pages/po-submitted').then((module) => ({
    default: module.PoSubmittedPage,
  })),
);

const PoLatePage = lazy(() =>
  import('@/pages/po-late').then((module) => ({
    default: module.PoLatePage,
  })),
);

const DeliveryPage = lazy(() =>
  import('@/pages/delivery').then((module) => ({
    default: module.DeliveryPage,
  })),
);

const PlanPage = lazy(() =>
  import('@/pages/plan').then((module) => ({
    default: module.PlanPage,
  })),
);

const MrpPage = lazy(() =>
  import('@/pages/mrp').then((module) => ({
    default: module.MrpPage,
  })),
);

const PendingOrderPage = lazy(() =>
  import('@/pages/pending-order').then((module) => ({
    default: module.PendingOrderPage,
  })),
);

const SingleOrderPage = lazy(() =>
  import('@/pages/single-order').then((module) => ({
    default: module.SingleOrderPage,
  })),
);

const KpiPage = lazy(() =>
  import('@/pages/kpi').then((module) => ({ default: module.KpiPage })),
);

const SystemPage = lazy(() =>
  import('@/pages/system').then((module) => ({ default: module.SystemPage })),
);

const SupplierPage = lazy(() =>
  import('@/pages/supplier').then((module) => ({
    default: module.SupplierPage,
  })),
);

const RolePermissionPage = lazy(() =>
  import('@/pages/role-permission').then((module) => ({
    default: module.RolePermissionPage,
  })),
);

const ExternalApprovalPage = lazy(() =>
  import('@/pages/external-approval').then((module) => ({
    default: module.ExternalApprovalPage,
  })),
);

const ItemPage = lazy(() =>
  import('@/pages/item').then((module) => ({
    default: module.ItemPage,
  })),
);

const ManufacturingTypePage = lazy(() =>
  import('@/pages/manufacturing-type').then((module) => ({
    default: module.ManufacturingTypePage,
  })),
);

const EmployeePage = lazy(() =>
  import('@/pages/employee').then((module) => ({
    default: module.EmployeePage,
  })),
);

const WarehousePage = lazy(() =>
  import('@/pages/warehouse').then((module) => ({
    default: module.WarehousePage,
  })),
);

const HolidayPage = lazy(() =>
  import('@/pages/holiday').then((module) => ({
    default: module.HolidayPage,
  })),
);

const CalcParamPage = lazy(() =>
  import('@/pages/calc-param').then((module) => ({
    default: module.CalcParamPage,
  })),
);

const CategoryMapPage = lazy(() =>
  import('@/pages/category-map').then((module) => ({
    default: module.CategoryMapPage,
  })),
);

const BomPage = lazy(() =>
  import('@/pages/bom').then((module) => ({
    default: module.BomPage,
  })),
);

const DocTemplatePage = lazy(() =>
  import('@/pages/doc-template').then((module) => ({
    default: module.DocTemplatePage,
  })),
);

const ErpPoLinePage = lazy(() =>
  import('@/pages/erp-po-line').then((module) => ({
    default: module.ErpPoLinePage,
  })),
);

const ErpSyncPage = lazy(() =>
  import('@/pages/erp-sync').then((module) => ({
    default: module.ErpSyncPage,
  })),
);

export const homePageRoute: RouteObject = {
  path: Urls.main.path,
  element: createElement(MainPage),
};

export const poAllRoute: RouteObject = {
  path: Urls.poAll.path,
  element: createElement(PoAllPage),
};

export const poActionRoute: RouteObject = {
  path: Urls.poAction.path,
  element: createElement(PoActionPage),
};

export const poSubmittedRoute: RouteObject = {
  path: Urls.poSubmitted.path,
  element: createElement(PoSubmittedPage),
};

export const poLateRoute: RouteObject = {
  path: Urls.poLate.path,
  element: createElement(PoLatePage),
};

export const deliveryRoute: RouteObject = {
  path: Urls.delivery.path,
  element: createElement(DeliveryPage),
};

export const planRoute: RouteObject = {
  path: Urls.plan.path,
  element: createElement(PlanPage),
};

export const mrpRoute: RouteObject = {
  path: Urls.mrp.path,
  element: createElement(MrpPage),
};

export const pendingOrderRoute: RouteObject = {
  path: Urls.pendingOrder.path,
  element: createElement(PendingOrderPage),
};

export const singleOrderRoute: RouteObject = {
  path: Urls.singleOrder.path,
  element: createElement(SingleOrderPage),
};

export const kpiRoute: RouteObject = {
  path: Urls.kpi.path,
  element: createElement(KpiPage),
};

export const systemRoute: RouteObject = {
  path: Urls.system.path,
  element: createElement(SystemPage),
};

export const supplierRoute: RouteObject = {
  path: Urls.supplier.path,
  element: createElement(SupplierPage),
};

export const rolePermissionRoute: RouteObject = {
  path: Urls.rolePermission.path,
  element: createElement(RolePermissionPage),
};

export const externalApprovalRoute: RouteObject = {
  path: Urls.externalApproval.path,
  element: createElement(ExternalApprovalPage),
};

/* IPH-12 기준정보 — 품목. 조회는 USER, 구매조건·단가·물류 쓰기는 MANAGER 다. */
export const itemRoute: RouteObject = {
  path: Urls.item.path,
  element: createElement(ItemPage),
};

/* IPH-12 기준정보 — 단순 마스터. 조회는 USER, 쓰기는 엔드포인트별 권한이다. */
export const manufacturingTypeRoute: RouteObject = {
  path: Urls.manufacturingType.path,
  element: createElement(ManufacturingTypePage),
};

export const employeeRoute: RouteObject = {
  path: Urls.employee.path,
  element: createElement(EmployeePage),
};

export const warehouseRoute: RouteObject = {
  path: Urls.warehouse.path,
  element: createElement(WarehousePage),
};

export const holidayRoute: RouteObject = {
  path: Urls.holiday.path,
  element: createElement(HolidayPage),
};

export const calcParamRoute: RouteObject = {
  path: Urls.calcParam.path,
  element: createElement(CalcParamPage),
};

export const categoryMapRoute: RouteObject = {
  path: Urls.categoryMap.path,
  element: createElement(CategoryMapPage),
};

/* IPH-12 기준정보 — BOM 변형 분류·판매 비율. 편집은 MANAGER, 전개 재생성은 ADMIN. */
export const bomRoute: RouteObject = {
  path: Urls.bom.path,
  element: createElement(BomPage),
};

/* IPH-12 기준정보 — 문서 양식. 조회 USER, 발행·수정 ADMIN. */
export const docTemplateRoute: RouteObject = {
  path: Urls.docTemplate.path,
  element: createElement(DocTemplatePage),
};

/* IPH-12 기준정보 — ERP 발주 라인 대사. 조회 전용이다. */
export const erpPoLineRoute: RouteObject = {
  path: Urls.erpPoLine.path,
  element: createElement(ErpPoLinePage),
};

export const erpSyncRoute: RouteObject = {
  path: Urls.erpSync.path,
  element: createElement(ErpSyncPage),
};

export const basePageRoute = [
  homePageRoute,
  poAllRoute,
  poActionRoute,
  poSubmittedRoute,
  poLateRoute,
  deliveryRoute,
  planRoute,
  mrpRoute,
  singleOrderRoute,
  pendingOrderRoute,
  kpiRoute,
  systemRoute,
  supplierRoute,
  itemRoute,
  manufacturingTypeRoute,
  employeeRoute,
  warehouseRoute,
  holidayRoute,
  calcParamRoute,
  categoryMapRoute,
  bomRoute,
  docTemplateRoute,
  erpPoLineRoute,
  erpSyncRoute,
  rolePermissionRoute,
  externalApprovalRoute,
];
